import * as $ from "jquery";
import * as ko from "knockout";
import "./app/startup";
import labels from "./app/labels";
import "portalframework";
import "./register-components";
import "./app/tmp_binding_handlers";
import * as Framework from "portalframework";
import "bootstrap";
import * as OfflinePluginRuntime from "offline-plugin/runtime";
import { siteService } from "portalframework";
import { metrixLoginService } from "./services/authentication/metrix-login-service";
import { profileService, userService } from "services";
import { routesService, RoutesService } from "./services/routes/routes.service";
import * as toastr from "toastr";

OfflinePluginRuntime.install({
  onUpdating: () => {
    console.log("SW Event:", "onUpdating");
  },
  onUpdateReady: () => {
    console.log("SW Event:", "onUpdateReady");
    OfflinePluginRuntime.applyUpdate();
  },
  onUpdated: () => {
    console.log("SW Event:", "onUpdated");
    window.location.reload();
  },
  onUpdateFailed: () => {
    console.log("SW Event:", "onUpdateFailed");
  },
});
OfflinePluginRuntime.update();

$.get("/appsettings.json", function (appSettings) {
  Framework.system.apiURL(appSettings.env.api_url);
  Framework.system.PortalType(appSettings.env.PortalType);
  Framework.system.productImageURL(appSettings.env.products_image_url);
  siteService.getEnvironment().then((result: string) => {
    Framework.system.environment(result.replace(/\"/g, ""));
  });

  $.get(`${Framework.system.apiURL()}api/routes/GetRoutes`, (routes) => {
    const routesMapped = routes.map((r: any) => {
      return {
        url: r.url,
        params: {
          page: r.component_name,
          name: r.description,
        },
      };
    });

    RoutesService.Routes = routes;
    RoutesService.GuardIsActivated = appSettings.guardRoutes;
    routesService.initializeRouter(Framework.system.history, routesMapped);

    var route = routesService.currentRoute;

    // Need to call something on system and loginservice to make sure it's active and not trimmed by webpack
    // - this is needed so these modules are fully active prior to pages using them
    if (!Framework.system.signedIn()) {
    }
    metrixLoginService.access_token.valueHasMutated();

    if (Framework.system.signedIn() && appSettings.guardRoutes) {
      labels.update().then(() => {
        ko.applyBindings({ route: route, isLoggedIn: Framework.system.signedIn, history: history }, $("body")[0]);
      });

      profileService
        .getTFASettings()
        .then((result) => {
          RoutesService.TwoFactorSettings(result);

          if (result.restrictUser()) {
            routesService.navigate("/my_account");
          }

          const unwrapedRoute = ko.toJS(route);

          //check if it has one of the roles
          const foundRoute = routes.find((r) => r.component_name === unwrapedRoute.page);
          const routeRoles = foundRoute?.roles?.split(";")?.filter((r) => r) || [];
          if (!foundRoute || !routesService.containsAtLeastOneRole(userService.CurrentUser.roles, routeRoles)) {
            toastr.warning("cc_P_NO_PAGE_ACCESS");
            routesService.navigate("/");
          }
        })
        .catch((error) => {
          toastr.error(error?.message || JSON.stringify(error));
        });
    } else {
      labels.update().then(() => {
        ko.applyBindings({ route: route, isLoggedIn: Framework.system.signedIn, history: history }, $("body")[0]);
      });
    }
  });
});

// Basic hot reloading support. Automatically reloads and restarts the Knockout app each time
// you modify source files. This will not preserve any application state other than the URL.
declare var module: any;
if (module.hot) {
  module.hot.accept();
  module.hot.dispose(() => ko.cleanNode(document.body));
}
